<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title moduleIdentifier="mercadoLivre" :title="$t('mercadoLivre.account.label')">
        <div class="btnGroup" slot="header-right">
          <button @click="changeStatus(false)" v-bind:class="{ 'is-active': !account.active }" class="btn btn--info btn--outline">
            Inativo
          </button>
          <button @click="changeStatus(true)" v-bind:class="{ 'is-active': account.active }" class="btn btn--info btn--outline">
            Ativo
          </button>
        </div>
      </page-title>
      <div class="l-row vertical-flex">
        <div class="l-col-3@md img-account">
          <img v-if="account.logo" :src="account.logo"/>
          <i v-if="!account.logo" class="icon-image2 no-photo"/>
        </div>
        <div class="l-col-9@md">
          <panel title="Dados da conta">
            <span class="ds-block"><strong>Nome:</strong> {{ account.name | attribute }}</span>
            <span class="ds-block"><strong>Nick:</strong> {{ account.nickname | attribute }}</span>
            <span class="ds-block"><strong>E-mail:</strong> {{ account.email | attribute }}</span>
          </panel>
        </div>
      </div>
      <div class="l-row">
        <div class="l-col-12@md">
          <panel title="Autenticação">
            <div slot="header-right">
              <button class="hint hint--left btn" @click="refreshToken" data-label="Renovar token"><i class="icon-sync icon-loop2"></i></button>
            </div>
            <span class="ds-block"><strong>Token de acesso:</strong> {{ account.accessToken | attribute }}</span>
            <span class="ds-block"><strong>Token de renovação:</strong> {{ account.refreshToken | attribute }}</span>
            <span class="ds-block"><strong>Data de expiração:</strong> {{ account.expirationDate | moment('DD/MM/YYYY HH:mm:ss') }}</span>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import ModuleLogo from '@/components/template/ModuleLogo'
  import notifier from '@/notifier'
  import api from '@/api'
  import Panel from '@/components/template/Panel'

  export default {
    props: {
      identifier: {
        type: String,
        required: false
      }
    },
    data: () => ({
      loading: true
    }),
    async mounted () {
      if (!this.account) {
        await this.fetchAccounts({})
      }

      this.loading = false
    },
    methods: {
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts',
        'setAccount'
      ]),
      isActive () {
        return {
          'success': this.account.active,
          'error': !this.account.active
        }
      },
      getStatusLabel (status) {
        if (status) {
          return 'mercadoLivre.accounts.active.label'
        }
        return 'mercadoLivre.accounts.inactive.label'
      },
      editAction () {
        return this.$router.push(`marketplace/mercado_livre/accounts/` + this.account.identifier)
      },
      async refreshToken () {
        try {
          const refreshedAccount = (await api.mercadoLivre.refreshToken(this.account.identifier))

          this.setAccount(refreshedAccount)

          notifier.success(`Token da conta renovado com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error('Erro na renovação do token da conta.', 'Erro')
        }
      },
      async changeStatus (status) {
        if (this.account.active === status) {
          return false
        }

        try {
          await api.mercadoLivre.updateAccountStatus(this.account.identifier, status)

          this.account.active = status

          notifier.success(`Status da conta alterado com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error('Erro na alteração de status da conta.', 'Erro')
        }
      }
    },
    computed: {
      ...mapGetters('mercadoLivreAccounts', [
        'getAccount'
      ]),
      account () {
        return this.getAccount(this.identifier)
      }
    },
    components: {
      Loader,
      PageTitle,
      ModuleLogo,
      Panel
    }
  }
</script>

<style lang="sass" scoped>
  .img-account
    text-align: center
    padding: 30px 0

    img
      max-height: 100%
      margin: 5px 0 16px
      max-width: 150px

    .no-photo
      font-size: 150px
      color: darkgrey
</style>



// WEBPACK FOOTER //
// Edit.vue?df0b964e